import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

interface ActionButton {
  label: string;
  href?: string;
  onClick?: () => void;
  variant?: 'default' | 'outline' | 'ghost' | 'secondary' | 'destructive';
  className?: string;
  icon?: React.ReactNode;
}

interface BannerActionsProps {
  primary: ActionButton;
  secondary?: ActionButton;
  layout?: 'stacked' | 'horizontal';
  spacing?: 'normal' | 'tight';
}

export const BannerActions: React.FC<BannerActionsProps> = ({
  primary,
  secondary,
  layout = 'horizontal',
  spacing = 'normal'
}) => {
  const getContainerClasses = () => {
    const layoutClasses = layout === 'stacked' 
      ? 'flex-col' 
      : 'flex-col sm:flex-row';
    
    const spacingClasses = spacing === 'tight' ? 'gap-2' : 'gap-3';
    
    return `flex ${layoutClasses} ${spacingClasses} justify-center pt-2`;
  };

  const renderButton = (action: ActionButton, isPrimary: boolean = false) => {
    const handleClick = () => {
      if (action.onClick) {
        action.onClick();
      }
    };

    const buttonContent = (
      <>
        {action.icon}
        {action.label}
      </>
    );

    const buttonProps = {
      size: "lg" as const,
      variant: action.variant || (isPrimary ? 'default' : 'ghost'),
      className: action.className || '',
      onClick: handleClick
    };

    if (action.href) {
      return (
        <Button asChild {...buttonProps}>
          <Link to={action.href}>
            {buttonContent}
          </Link>
        </Button>
      );
    }

    return (
      <Button {...buttonProps}>
        {buttonContent}
      </Button>
    );
  };

  return (
    <div className={getContainerClasses()}>
      {renderButton(primary, true)}
      {secondary && renderButton(secondary, false)}
    </div>
  );
};